
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire591d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire591d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $3a037de1bc195212$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["kb9mm","index.9b928b70.js","6Gp8O","circle.c17d6a03.png","5fPxq","earthmap1k.f2c357af.png","leyJ8","earthlights1k.40c9e504.jpg","kAn9g","earthspec1k.7eb0224f.jpg","1uSma","earthbump1k.e5ea8826.jpg","icNhE","earthcloudmap.653b8f17.jpg","29Dlx","moonmap4k.75403463.jpg","ivosn","moonbump4k.a462416a.jpg","l8PSl","jupiter.4cbea6d5.jpg","edZuf","jupiternight.3561879c.jpg","jSvXD","mercurymap.f38e372b.jpg","i9Vjq","mercurybump.1f755244.jpg","hVsdB","mercurynightmap.da05a230.jpg","gfWgf","venusmap.bef9de08.jpg","7YEQJ","venusmapnight.a8c6b0a3.jpg","6ptJh","venusclouds.51c90987.jpg","7MsIx","marsmap.cfa5e586.png","6wXHg","marsbump.3f2134f3.jpg","ghyz7","marsclouds.45876aa4.png","9j7Eh","marsnight.f8ee7a8e.jpg","azus2","th_saturn.5296d502.png","fo2gG","th_saturnbump.e6690123.png","bIAxf","th_saturnclouds.280754c7.png","gncgQ","th_saturnnight.e8d208b5.png","76TrM","t00fri_gh_saturnrings.603b98d9.png","knsKa","uranusmap.59c8d073.png","9lxz5","uranuslights.30a53f6e.png","41j7G","uranusrings.b148ab5d.png","ea82v","neptunemap.115c5f8f.jpg","g7Adm","neptunebump.e4ee8ce1.png","92Tn0","neptuneclouds.0b421134.png","5OwJ1","neptunelights.9f365827.jpg","3BmHk","neptunerings.69a856e4.png","1mjDC","sunmap.defafe91.jpg","969H4","sunintro.70ab5330.wav","hHXZ5","sunfact1.f8866042.wav","hNATp","sunfact2.79d9ea73.wav","1TkrE","sunfact3.5655b0e2.wav","lT5BY","welcome.5c875f5b.wav","dHOPV","mercuryintro.33f220be.wav","kpAtn","mercuryfact1.94eeb4dd.wav","cXEmr","mercuryfact2.a2489574.wav","3Hk4q","mercuryfact3.621a93e6.wav","1PFuZ","venusintro.a3228cbc.wav","5f6nH","venusfact1.b3084057.wav","azaD3","venusfact2.8cac3043.wav","aAc7U","venusfact3.d12d368e.wav","cfboe","venusfact4.121ff8f3.wav","3LyFE","venusfact5.79dd68c5.wav","62Rub","venusfact6.f3bd3649.wav","dyE6W","earthintro.1c3fa1e8.wav","aQFS6","earthfact1.fdfe72af.wav","gtma4","earthfact2.4f231232.wav","9gZUp","earthfact3.7749765d.wav","4iQxO","marsintro.47c519a6.wav","9WMd6","marsfact1.2fd7b3e3.wav","FpHYj","marsfact2.ba03ac2e.wav","gCQK4","marsfact3.7728f91b.wav","kU7cO","marsfact4.5c5ea0ec.wav","cyGMT","jupiterintro.d4ae3f53.wav","2Jun9","jupiterfact1.5e769a51.wav","dL0PI","jupiterfact2.324fbb29.wav","iNEtQ","jupiterfact3.324b759a.wav","k3bEq","jupiterfact4.40362a6f.wav","cpi03","saturnintro.c355e452.wav","4RyjN","saturnfact1.8c3f5166.wav","7Uyqs","saturnfact2.cb4332a4.wav","i0Xqn","saturnfact3.51096627.wav","5t0Mk","uranusintro.f431e327.wav","8Pakm","uranusfact1.5bf4d89d.wav","lygay","uranusfact3.c68aea47.wav","dbXSW","uranusfact4.96fd9f72.wav","bAiSR","neptuneintro.e424f203.wav","4v9JO","neptunefact1.52bef686.wav","khEx1","neptunefact2.b150ef6b.wav","jnID4","neptunefact3.66534034.wav","5c6NR","neptunefact4.cb0c7b46.wav","dMDcZ","neptunefact5.e373f872.wav","7jnBb","moonintro.26c7eb1b.wav","2yod7","moonfact1.18957888.wav","54YU0","moonfact2.55b5885b.wav","bxGlD","moonfact3.a322be46.wav","kDCEs","moonfact4.9552e8c7.wav","hhrXc","asteroid1.2bf3255d.wav","jtZ7P","asteroid2.de4fd76f.wav","e3dTU","NEA.d63e7624.png","31czz","NEC.65aded17.png","9qf0i","PHA.6652c959.png","bx2YE","asteroidMap.9620119f.jpg","4lZ3L","asteroidBumpMap.56197330.png","i8BcN","eros.cda6f183.glb"]'));


//# sourceMappingURL=index.runtime.73a98524.js.map
